import React, { useState, useRef } from 'react';

interface RemoteFilterDropdownProps {
  show: boolean;
  selectedRemoteTypes: string[];
  onClose: () => void;
  onApply: (remoteTypes: string[]) => void;
  buttonRef: React.RefObject<HTMLButtonElement>;
}

const remoteOptions = [
  { value: 'remote', label: 'リモートOK' },
  { value: 'full_remote', label: 'フルリモート' },
  { value: 'onsite', label: '常駐' }
];

const RemoteFilterDropdown: React.FC<RemoteFilterDropdownProps> = ({
  show,
  selectedRemoteTypes,
  onClose,
  onApply,
  buttonRef
}) => {
  const [currentSelection, setCurrentSelection] = useState<string[]>(selectedRemoteTypes);
  const dropdownRef = useRef<HTMLDivElement>(null);

  React.useEffect(() => {
    if (show) {
      setCurrentSelection(selectedRemoteTypes);
    }
  }, [show, selectedRemoteTypes]);

  React.useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target as Node) &&
          buttonRef.current && !buttonRef.current.contains(event.target as Node)) {
        onClose();
      }
    };

    if (show) {
      document.addEventListener('mousedown', handleClickOutside);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [show, onClose, buttonRef]);

  const handleCheckboxChange = (remoteType: string) => {
    const newSelection = currentSelection.includes(remoteType)
      ? currentSelection.filter(type => type !== remoteType)
      : [...currentSelection, remoteType];
    
    setCurrentSelection(newSelection);
    
    // リモートタイプ選択時に自動的に検索を実行
    onApply(newSelection);
  };

  const handleApply = () => {
    onApply(currentSelection);
    onClose();
  };

  if (!show) return null;

  return (
    <div 
      ref={dropdownRef}
      className="position-absolute bg-white border rounded shadow-lg" 
      style={{ 
        top: '100%', 
        left: 0, 
        right: 0, 
        zIndex: 1000,
        maxHeight: '400px',
        overflowY: 'auto',
        minWidth: '500px'
      }}
    >
      <div className="p-3">
        <div className="d-flex justify-content-between align-items-center mb-3">
          <h6 className="mb-0">勤務形態で絞り込み</h6>
          <button type="button" className="btn-close" onClick={onClose}></button>
        </div>
        
        <ul className="list-group list-group-flush">
          {remoteOptions.map(option => (
            <li key={option.value} className="list-group-item">
              <div className="form-check">
                <input
                  className="form-check-input"
                  type="checkbox"
                  id={`remote-${option.value}`}
                  checked={currentSelection.includes(option.value)}
                  onChange={() => handleCheckboxChange(option.value)}
                />
                <label className="form-check-label" htmlFor={`remote-${option.value}`}>
                  {option.label}
                </label>
              </div>
            </li>
          ))}
        </ul>
        
        <div className="d-flex gap-2 mt-3">
          <button type="button" className="btn btn-outline-secondary btn-sm" onClick={onClose}>
            キャンセル
          </button>
          <button type="button" className="btn btn-primary btn-sm" onClick={handleApply}>
            この条件で検索
          </button>
        </div>
      </div>
    </div>
  );
};

export default RemoteFilterDropdown;
